import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";

@Injectable()
export class TitleService {
    baseTitle: string;
    constructor(private titleService: Title) {
        this.baseTitle = titleService.getTitle();
    }

    setTitle(pageTitle: string) {
        this.titleService.setTitle(this.baseTitle + " | " + pageTitle);
    }
}
